module.exports = __webpack_public_path__ + "static/media/typeApartment.bd4c5a3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/generalInformation/typeApartment.svg
// module id = 304
// module chunks = 0